import React from 'react';
export function ValueStack() {
  return <section id="value" aria-label="Offer summary" data-id="element-283" data-mp="1ujgqfij5qyu4" />;
}